<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0" v-if="competition">{{ competition.name }} Competition</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <b-row v-if="competition">
        <b-col md="8">
          <b-card no-body>
            <b-card-header><h3 class="mb-0">{{ competition.name }} Competition</h3></b-card-header>
            <b-card-body>
              <div v-html="competition.description"></div>
              <b-button variant="danger" @click="unregister" v-if="currentCompIds.includes(competition.id)">Unregister</b-button>
            </b-card-body>
          </b-card>
        </b-col>
        <scoreboard :competition="competition" :scoreboard="scoreboard" :size="'4'" v-if="currentCompIds.includes(competition.id)"></scoreboard>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import Scoreboard from './Scoreboard';

export default {
  components: {
    RouteBreadCrumb,
    Scoreboard
  },
  data() {
    return {
      competitions: null,
      competition: null,
      scoreboard: []
    }
  },
  computed: {
    ...mapGetters({
      userRoute: 'profile/userRoute',
      totalListingsTaken: 'economicModel/totalListingsTaken'
    }),
    currentCompIds() {
      return this.competitions ? this.competitions.map(a => a.id) : [];
    }
  },
  methods: {
    async getCompetitions() {
      await axios.get(this.userRoute + '/competitions')
      .then(response => {
        this.competitions = response.data;
      })
      .catch(error => {
        // error
      });
    },
    async getCompetition() {
      await axios.get(process.env.VUE_APP_API_BASE_URL + "/competitions/" + this.$route.params.id)
      .then(response => {
        this.competition = response.data;
      })
      .catch(error => {
        // error
      });
    },
    async getScoreboard() {
      await axios.get(this.userRoute + "/competitions/" + this.$route.params.id + "/scoreboard")
      .then(response => {
        this.scoreboard = response.data;
      })
      .catch(error => {
        // error
      });
    },
    unregister() {
      swal.fire({
        title: 'Unregister',
        text: 'Are you sure you would like to unregister from this competition?',
        type: 'danger',
        showCancelButton: false,
        confirmButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Unregister',
        buttonsStyling: false,
        icon: 'question'
      }).then(result => {
        if(result.isConfirmed) {
          this.submitUnregistration();
        }
      });
    },
    async submitUnregistration() {
      await axios.post(this.userRoute + "/competitions/unregister", {
        competition_id: competition.id
      })
      .then(response => {
        swal.fire({
          title: `Success`,
          text: response.data,
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        }).then(result => {
          this.$router.push("/competitions");
        });
      })
      .catch(error => {
        // error
      });
    }
  },
  created() {
    this.getCompetitions();
    this.getCompetition();
    this.getScoreboard();
  }
};
</script>